import { Component } from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';

export default class PureRenderComponent extends Component {
    shouldComponentUpdate () {
        return PureRenderMixin.shouldComponentUpdate.apply(this, arguments);
    }
}
